<ng-container>
  @if(isPageRestrictionLoaded){
  <div class="ppl-container-body">
    <div class="ppl-container-head"><h1 class="page-title-accessibility" tabindex="-1" pplAutoFocusHeader>File Upload Notification</h1></div>
    <div class="ppl-container">
      <div class="ppl-content-container">
        <div class="table-style">
          <ppl-list-table
            [pageConfig]="programName"
            [sharedDataKey]="sharedDataKey"
            (rowDetailEvent)="rowClicked($event)"
            [loadPage]="lazyLoad"
            [columnsToBeHidden]="columnsToBeHidden"
            [actionsToBeHidden]="actionsToBeHidden"
            [jsonList]="'list_file_upload_notification'"
            rowDataAccessibilityKey="fileName"
            [from]="'fun'"
            [listButton]="buttons"
          />
        </div>
      </div>
    </div>
  </div>
  }
</ng-container>
